import { UI, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import { VariationStyle } from '../../../../../../../../store/product/types';

export interface AssetValueWithVariationProps {
  value: string;
  variation: VariationStyle;
}

export const AssetValueWithVariation: React.FC<AssetValueWithVariationProps> = ({
  value,
  variation,
}) => {
  return (
    <HStack space={Spacing['inline.quarck']}>
      {!!variation.hasVariation && (
        <UI.Icon name={variation.icon} color={Color[variation.color]} size="xxxxs" />
      )}
      <UI.Text variant="semibold" color="neutral.darkest" noOfLines={1}>
        {value}
      </UI.Text>
    </HStack>
  );
};
